module.exports = __webpack_public_path__ + "img/brigadefutur3.4bc0181f.png";